import Component from '../inherited/Component'
import rivets from 'rivets'
import Helpers from '../lib/Helpers'
import AjaxApi from '../lib/AjaxApi'

class Cart extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._copyBasket = document.querySelector('.copy-basket')
    this._setup()
    this._doEditorListeners()
  }

  _setup () {
    this._data = {
      cart: {},
      upsellLoading: true,
      samplesLoading: true,
      hasUpsell: false,
      giftMessageOpen: false,
      samplesOpen: false,
      freeSamples: [],
      freeGifts: [],
      epamperEnabled: false
    }

    let extra = document.querySelector('[data-cart-extra]') ? JSON.parse(document.querySelector('[data-cart-extra]').innerHTML) : {}

    this._upsellAdded = false
    this._upsellHandles = []
    this._lastAddedItemUpsellHandles = []
    this._upsellOptions = document.querySelector('[data-upsell-options]') ? JSON.parse(document.querySelector('[data-upsell-options]').innerHTML) : {
      enabled: false,
      limit: 5,
      handles: []
    }

    this._upsellArea = document.querySelector('[data-cart-upsell-inner]')

    this._upsellOptions.handles = this._upsellOptions.handles.map(item => {
      return {
        handle: item
      }
    })

    this._shippingThresholdOptions = document.querySelector('[data-shipping-threshold-options]') ? JSON.parse(document.querySelector('[data-shipping-threshold-options]').innerHTML) : {
      enabled: false
    }

    this._renderAreas = document.querySelectorAll('[data-cart-mount]')
    this._jquery = window.$ || null

    this._data = {
      ...this._data,
      ...extra
    } 

    this._binds = []


  }
  
  _binders () {
    rivets.binders['style-*'] = function(el, value) {
      el.style.setProperty(this.args[0], value)
    }

    rivets.formatters.getSrcSet = (src, size) => {
      return src ? `${Helpers.getSizedImageUrl(src, size)} 1x, ${Helpers.getSizedImageUrl(src, size + '@2x')} 2x` : ''
    } 

    rivets.formatters.setDeliveryTime = (id)  => {
      const deliveryTimeJson = document.querySelector(`[data-variant-delivery-times="${id}"]`) ? JSON.parse(document.querySelector(`[data-variant-delivery-times="${id}"]`).innerHTML) : null;
      if (deliveryTimeJson) {
        const deliveryTime =  deliveryTimeJson.variants.find(variant => variant.id === id && variant.delivery_time !== null) || deliveryTimeJson.product;
        if (deliveryTime.delivery_time != null && deliveryTime.delivery_time != '0') {
          return deliveryTimeJson.message.replace('[x]', deliveryTime.delivery_time)
        } else {
          return deliveryTimeJson.in_stock_message
        }
      } else {
        return ''
      }
    }

    rivets.formatters.getSizedImage = (src, size) => {
      return src ? Helpers.getSizedImageUrl(src, size) : ''
    }

    rivets.formatters.money = (value) => {
      return Helpers.formatMoney(value, this._ctx.getState())
    }

    rivets.formatters.getCustomDiscount = (originalPrice, discount) => {
      if(discount.amount > 0) {
        return originalPrice - discount.amount
      } else if(discount.percentage > 0) {

        let percentage = discount.percentage / 100
        let discountedPrice = originalPrice * (1 - percentage)

        return discountedPrice
      }
      return
    } 

    rivets.formatters.length = (arr) => {
      return arr ? arr.length : 0
    }

    rivets.formatters.eq = (val, val2) => {
      return val === val2
    }

    rivets.formatters.gt = (val, val2) => {
      return val > val2
    }

    rivets.formatters.minus = (one, two) => {
      return one - two
    }

    rivets.formatters.getUrl = (handle) => {
      return `/products/${handle}`
    }

    rivets.formatters.getImage = (product, variant) => {
      return variant.featured_image ? variant.featured_image.src : product.featured_image
    }

    rivets.formatters.pluralize = (count, one, multiple) => {
      return count === 1 ? one : multiple
    }

    rivets.formatters.sampleAdded = (item) => {
      let sampleItems = this._sampleItems()

      return sampleItems.find(cItem => cItem.handle === item.handle)
    }

    rivets.formatters.getProps = (item) => {
      let props = []
      for (let key in item.properties) {
        if (key.charAt(0) === '_' || key === 'Preview') continue
          let name = key.charAt(0).toUpperCase() + key.slice(1)
        let value = item.properties[key]

        if (value.includes('https://cdn.shopify.com')) {
          value = `<img src="${value}" />`
        }

        props.push({ name: name, value: value })
      }
      return props
    }

    rivets.formatters.hasVariants = (item) => {
      return item.variants && item.variants[0].title !== 'Default Title'
    }

    rivets.formatters.hasFreeShipping = (count) => {
      let threshold = this._shippingThresholdOptions.threshold * 100.00
      return count >= threshold
    }

    rivets.formatters.comparePrice = (compare_price, quantity) => {
      return Helpers.formatMoney((compare_price * quantity), this._ctx.getState())
    }

    rivets.formatters.getCompareRrp = (price, rrp) => {
      if(rrp) {
        return 'RRP' + price
      } else {
        return price
      }
    }

    rivets.formatters.compareDifference = (price, compare_price, quantity) => {
      return Helpers.formatMoney(((compare_price * quantity) - price), this._ctx.getState())
    }
    
    rivets.formatters.getShippingNotice = (count) => {
      let threshold = this._shippingThresholdOptions.threshold * 100.00
      let under = this._shippingThresholdOptions.under
      let reachedNotice = this._shippingThresholdOptions.reached
      let remaining = threshold - count

      under = under.replace('[x]', Helpers.formatMoney(remaining, this._ctx.getState()))
      return count >= threshold ? reachedNotice : under
    }
  }

  async mount () {
    this._data.cart = await this.prepareData(await AjaxApi.getCart())
    this._prepareUpsellData()

    if (typeof window.BOLD !== 'undefined'
     && typeof window.BOLD.common !== 'undefined'
     && typeof window.BOLD.common.cartDoctor !== 'undefined') {
           // NOTE: "cart" should be the variable containing the cart JSON data
         this._data.cart = window.BOLD.common.cartDoctor.fix(this._data.cart);
       }
       
       this._data.cartBackup = {...this._data.cart}

       this._ctx.on('cart-item-added', async () => {
        this._data.cart.loading = true
        await this._refresh()
        this._ctx.emit('cart-item-added--refreshed')
      })

       this._binders()
       this._render()

       window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
       window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })

       if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', this._data.cart);
      }

      if (this._copyBasket) {
        this._copyBasket.addEventListener('click', () => {
          let currentPageUrl = window.location.href;
          let domain = currentPageUrl.split('/')[2];
          let domainParts = domain.split('.');
          let mainDomain = domainParts.slice(-2).join('.');
          let fullMainDomain = "https://" + mainDomain + "/";
          let productsUrls = this._data.cart.items.map(item => { return fullMainDomain+item.url })
          let urlsText = productsUrls.join('\n');
          this._copyToClipboard(urlsText)
          this._copyBasket.innerHTML = "Basket Content Copied!"
        });
      }
    }


    _copyToClipboard(text) {
      navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Texto copiado al portapapeles');
      })
      .catch(err => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    async prepareData (data) {
      this._upsellHandles = []

      let promises = []

      let saving = 0;

      let i = 0

      let item = data.items.find(item => `${item.variant_id}` === `${this._ctx.getState().lastItemAdded?.item?.id}`)

      for (const [i, item] of data.items.entries()) {
        promises.push(new Promise(async (res, rej) => {
          item.index = i + 1;
          let data = await AjaxApi.getCustomProduct(item.handle);
          item.product = data.product;
          if (item.product.compare_at_price != null) {
            saving += item.product.compare_at_price - item.product.price;
          }
          item.product.metafields = data.metafields;
          item.upsell_handles = data.upsell_products

          if(data.discounts) {
            item.custom_discounts = data.discounts
          }

          item.variant = item.product.variants.find((variant) => variant.id === item.variant_id);
          res();
        }));
      }

      await Promise.all(promises)

      data.lastAddedItem = data.items.find(item => `${item.variant_id}` === `${this._ctx.getState().lastItemAdded?.item?.id}`)

      if (!data.lastAddedItem && data.items.length > 0) {
        data.lastAddedItem = data.items.at(-1)
      }

      if (data.lastAddedItem) {
        this._upsellHandles = data.lastAddedItem.upsell_handles

        if(data.lastAddedItem.properties && data.lastAddedItem.properties['_bundleId']) {
          data.lastAddedItems = data.items.filter(item => item.properties['_bundleId'] == data.lastAddedItem.properties['_bundleId'])
        } else {
          data.lastAddedItems = [data.lastAddedItem]
        }
      }

      data.saving = saving
      data.loading = false
      let upsellOptionsHandlesString = this._upsellOptions.handles.map(obj => obj.handle).join(',');
      this._upsellHandles = this._upsellHandles + ',' + upsellOptionsHandlesString;

      this._upsellHandles = this._upsellHandles.split(',');
      this._upsellHandles = this._upsellHandles.map(handle => {
        return { handle: handle };
      });


      //Remove Empty
      this._upsellHandles =  this._upsellHandles.filter(obj => obj.handle !== "");

      // Use previous upsell items if current are empty
      if (this._upsellHandles.length == 0 && this._lastAddedItemUpsellHandles.length > 0) {
        this._upsellHandles = this._lastAddedItemUpsellHandles
      }

      // Remove duplicates
      this._upsellHandles = this._upsellHandles.filter((item, index) => {
        let otherIndex = this._upsellHandles.map(item => item.handle).indexOf(item.handle)
        return otherIndex === index
      })

      // // Remove already in cart
      // this._upsellHandles = this._upsellHandles.filter(obj => {
      //   if (obj.variantId) {
      //     return !data.items.some(item => obj.variant_id === item.variant_id)
      //   } else {
      //     return !data.items.some(item => obj.handle === item.handle)
      //   }
      // })

      if (this._upsellOptions.limit > 0) {
        this._upsellHandles = this._upsellHandles.slice(0, this._upsellOptions.limit)
      }
      
      this._lastAddedItemUpsellHandles = this._upsellHandles

      this._data.hasUpsell = this._upsellHandles.length > 0 && this._upsellOptions.enabled && this._upsellOptions.limit > 0

      return data
    }

      async _prepareUpsellData () {
        if (!this._upsellOptions.enabled) {
          return false
        }
        this._data.upsellLoading = true
        let results = []
        let promises = []

        for (let handleObj of this._upsellHandles) {
          if (this._data.cart.items.some(cartItem => cartItem.handle === handleObj)) {
            continue;
          }
          promises.push(new Promise(async (res, rej) => {
            try {
              let handle = handleObj.handle
              let data = await AjaxApi.getCustomProduct(handle)
              let item = data.product

              item.metafields = data.metafields
              item.options = data.options
              item.why_buy = data.why_buy? data.why_buy : null
              item.why_buy_check = data.why_buy? true : false

              if(data.discounts) {
                item.custom_discounts = data.discounts
                
                for(let discount of item.custom_discounts) {
                  let lastAddedMatch = this._data.cart.lastAddedItem.custom_discounts?.find(parentDiscount => parentDiscount.id == discount.id && parentDiscount.type !== discount.type)
                  if(lastAddedMatch && Object.keys(lastAddedMatch).length > 0) {
                    item.custom_discount = discount
                    break
                  }
                }
    
                delete item.custom_discounts
              }

              if (handleObj.variantId) {
                item.currentVariant = item.variants.find(variant => Number(variant.id) == Number(handleObj.variantId))
              }

              if (handleObj.preferredOptions) {
                item.currentVariant = item.variants.find(variant => {
                  return variant.options.every( option => handleObj.preferredOptions.includes(option))
                })

                if (!item.currentVariant) {
                  item.currentVariant = item.variants.find(variant => {
                    return variant.options.some( option => handleObj.preferredOptions.includes(option))
                  })
                }
              }

              if (!item.currentVariant || !item.currentVariant.available) {
                item.currentVariant = item.variants.find(variant => variant.available)
              }
              item.quantity = 1
              
              if (item.currentVariant && item.options) {
                for (let option of item.options) {
                  option.selectedValue = item.currentVariant.options[option.position - 1]
                }
              }

              if (item.available) {
                results.push(item)
              }

              res()
            } catch(e) {
              console.log(e)
              res()
            }
          }))
        }
        await Promise.all(promises)

        results = results.sort((a, b) => {
          let indexA = this._upsellHandles.map(item => item.handle).indexOf(a.handle)
          let indexB = this._upsellHandles.map(item => item.handle).indexOf(b.handle)
          return indexA - indexB
        })


        this._data.hasUpsell = results.length > 0
        this._data.upsellProducts = results
        this._data.upsellLoading = false

/*         if (this._upsellArea) {
          this._upsellArea.style.minHeight = `${this._upsellArea.scrollHeight}px`
        }
        */
      }

      _render () {
        for (let cartSection of this._renderAreas) {
          this._binds.push(rivets.bind(cartSection, this._getModel(cartSection)))
        }

        this._data.cart.loading = false

        for (let cartSection of this._renderAreas) {
          cartSection.classList.add('rendered')
        }
      }

      unmount () {
        console.log('unmount cart')

        for (let bind of this._binds) {
          bind.unbind()
        }
      }

      _getModel (cartSection) {
        return {
          data: this._data,
          controller: {
            removeItem: async (e, model) => {
              e.preventDefault()
              model.data.cart.loading = true
              let item = model.item
              await AjaxApi.removeCartItem(item.key)
              this._refresh()
            },
            updateQuantity: async (e, model) => {
              e.preventDefault()
              if (model.item.quantity.length && isNaN(parseInt(model.item.quantity))) {
                model.item.quantity = 1
                return false
              }
              if (model.item.quantity.length) {
                model.data.cart.loading = true
                var newQuantity = model.item.quantity

                try {
                  await AjaxApi.updateCartItem(model.item.key, newQuantity, model.item.properties)
                  this._refresh()
                } catch (err) {
                  model.data.cart.loading = false
                  this._data.errorMessage = `All ${model.item.title} are currently in your cart`
                }
              }
            },
            incrementQuantity: async (e, model) => {
              e.preventDefault()
              model.data.cart.loading = true
              var newQuantity = model.item.quantity + 1

              try {
                await AjaxApi.updateCartItem(model.item.key, newQuantity, model.item.properties)
                this._refresh()
              } catch (err) {
                model.data.cart.loading = false
                this._data.errorMessage = `All ${model.item.title} are currently in your cart`
              }
            },
            decrementQuantity: async (e, model) => {
              e.preventDefault()
              model.data.cart.loading = true
              var newQuantity = model.item.quantity - 1

              try {
                await AjaxApi.updateCartItem(model.item.key, newQuantity, model.item.properties)
                this._refresh()
              } catch (err) {
                model.data.cart.loading = false
                this._data.errorMessage = `All ${model.item.title} are currently in your cart`
              }
            },
            clearError: (e, model) => {
              e.preventDefault()
              model.data.errorMessage = null
            },
            showWhyBuy: (e, model) => {
              e.preventDefault()
              const cartItemUpsell = e.target.closest('.cart-item--upsell__content')
              const whyBuy = cartItemUpsell.querySelector('.cart-item--upsell__why-buy')
              whyBuy.classList.add('shown')
            },
            closeWhyBuy: (e, model) => {
              e.preventDefault()
              const cartItemUpsell = e.target.closest('.cart-item--upsell__content')
              const whyBuy = cartItemUpsell.querySelector('.cart-item--upsell__why-buy')
              whyBuy.classList.remove('shown')
            },
            addUpsellItem: async (e, model) => {
              e.preventDefault()
              let product = model.item
              let variant = product.currentVariant
              model.data.cart.loading = true
              this._upsellAdded = true

              let properties = {}
              
              if (product.metafields['is_preorder'] === 1) {
                properties["_is-preorder"] = 'Yes'
              }

              let obj = {
                id: `${variant.id}`,
                quantity: product.quantity,
                properties: properties
              }

              if (variant.requires_selling_plan) {
                obj.selling_plan = variant.selling_plan_allocations[0].selling_plan_id
              }
              
              let data = await AjaxApi.addToCart(obj)

              this._ctx.emit('cart-item-added', {
                lastItemAdded: {
                  item: data,
                  quantity: product.quantity,
                  properties: properties
                }
              })
            },
            incrementUpsellQuantity: (e, model) => {
              e.preventDefault()
              model.item.quantity++
            },
            decrementUpsellQuantity: (e, model) => {
              e.preventDefault()
              if (model.item.quantity > 1) {
                model.item.quantity--
              }
            }
          }
        }
      }

      async _refresh () {
        this._data.cart.lastAddedItems = []
        this._data.cart = await this.prepareData(await AjaxApi.getCart())

        this._prepareUpsellData()

        if (typeof window.BOLD !== 'undefined'
         && typeof window.BOLD.common !== 'undefined'
         && typeof window.BOLD.common.cartDoctor !== 'undefined') {
           // NOTE: "cart" should be the variable containing the cart JSON data
         this._data.cart = window.BOLD.common.cartDoctor.fix(this._data.cart);
       }

       this._data.cartBackup = {...this._data.cart}

       if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize()
      }

      this._ctx.emit('radiant--cart-update', this._data.cart)

      window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })

      if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', this._data.cart);
      }
    }

    _getVariant (selectedOptions, variants) {
      let theVariant = false
      for (let variant of variants) {
        let foundVariant = variant
        for (let [index, option] of selectedOptions.entries()) {
          if (variant[`option${index + 1}`] !== option) {
            foundVariant = false
          }
        }
        if (foundVariant) {
          theVariant = foundVariant
          break
        }
      }
      return theVariant
    }

    _getUpdatesMap (items = this._data.cart.items) {
      return items.map(item => item.quantity)
    }

    _doEditorListeners () {
      document.addEventListener('shopify:section:unload', e => {
        this.unmount()
      })

      document.addEventListener('shopify:section:load', e => {
        this._setup()
        this.mount()
      })
    }
  }

  export default Cart
